module.exports = __webpack_public_path__ + "img/图片8.b6bb8ff2.png";